import { Button } from "@mantine/core";
import { useScrollIntoView } from '@mantine/hooks';
import React from "react";
import { FaDownload } from "react-icons/fa";
import { HiChevronDoubleDown, HiOutlineChevronDown } from "react-icons/hi";
import { Link } from "react-router-dom";
function Hero({main ,badge,  heroImage ,  smallText ,  outlineButton, description ,link , cv}) {
  const { scrollIntoView, targetRef } = useScrollIntoView({ offset: 60 });
  return (
    <>
    <div className="hero_wrapper_container">

      
      <div className="hero_context padding_container ">
            <div className="hero-grid-area">
                <div className="left">
                    {
                        badge  ? <img src={badge} alt="bage" /> : ""
                    }
                   {
                    main ? <h2>{main}</h2> : ""
                   }
                   {
                    smallText ?  <h6>{smallText}</h6> : ""
                   }

                   {
                    description ? <p>{description}</p>: ""
                   }

                   { !cv &&
                    outlineButton ? <Link to={link}>
                      <Button variant="outline" gradient={{ from: 'indigo', to: 'cyan' }}>{outlineButton}</Button>
                    </Link>:""
                   }
                   {
                    cv && <Button
                    component="a"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={cv}
                    leftIcon={<FaDownload size={18} />}
                    styles={(theme) => ({
                      root: {
                        backgroundColor: '#00acee',
                        border: 0,
                        height: 42,
                        paddingLeft: 20,
                        paddingRight: 20,
              
                        '&:hover': {
                          backgroundColor: theme.fn.darken('#00acee', 0.05),
                        },
                      },
              
                      leftIcon: {
                        marginRight: 15,
                      },
                    })}
                  >
                    Download Resume
                  </Button>
                   }
                </div>
                <div className="right">
                    <img src={ heroImage} alt=" heroImage" />
                </div>
                
                
            </div>
            <div className="scroll-area-in-hero">

              <HiChevronDoubleDown onClick={() => scrollIntoView({ alignment: 'center' })} size={50} />
              <HiOutlineChevronDown onClick={() => scrollIntoView({ alignment: 'center' })} size={45} />
            </div>
      </div>
    </div>
  
    <span ref={targetRef}></span>
    </>
  );
}

export default Hero;
